import { render, staticRenderFns } from "./members-rights.vue?vue&type=template&id=93fdfbf2&scoped=true"
import script from "./members-rights.vue?vue&type=script&lang=js"
export * from "./members-rights.vue?vue&type=script&lang=js"
import style0 from "./members-rights.vue?vue&type=style&index=0&id=93fdfbf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93fdfbf2",
  null
  
)

export default component.exports